import { ClockIcon } from "@heroicons/react/24/outline";
import CallButton from "components/CallButton";

export default function ArrangementNotReady() {
  return (
    <div className="mx-auto flex w-full max-w-lg flex-1 flex-col items-center justify-center px-4 py-16 text-center">
      <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-oat">
        <ClockIcon className="h-8 w-8 text-evergreen" />
      </div>
      <h1 className="font-serif text-[34px] font-normal leading-[1.15] text-soil">
        Your arrangement is being prepared
      </h1>
      <p className="mt-3 text-lg text-soil">
        Your care specialist is setting up your arrangement details.
        They&apos;ll reach out to you soon.
      </p>
      <div className="mt-8">
        <CallButton variant="outline" />
      </div>
    </div>
  );
}
